import { render, staticRenderFns } from "./unit-select.vue?vue&type=template&id=13f498ae&scoped=true&"
import script from "./unit-select.vue?vue&type=script&lang=ts&"
export * from "./unit-select.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f498ae",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Sources\\nothegger.topwm\\Nothegger.TopWM.Warehouse.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13f498ae')) {
      api.createRecord('13f498ae', component.options)
    } else {
      api.reload('13f498ae', component.options)
    }
    module.hot.accept("./unit-select.vue?vue&type=template&id=13f498ae&scoped=true&", function () {
      api.rerender('13f498ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/products/components/unit-select.vue"
export default component.exports